<template>
  <svg
    v-if="icon"
    :width="width"
    :height="height"
    :viewBox="viewBoxValue"
    xmlns="http://www.w3.org/2000/svg"
    v-html="icon"
  />
</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
  icon: { type: String },
  width: { type: Number, default: 24 },
  height: { type: Number, default: 24 },
  viewBox: { type: String },
});

const viewBoxValue = computed(
  () => props.viewBox || `0 0 ${props.width} ${props.height}`
);
</script>
